.context {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 10px 26px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  font-size: 13px;
  color: var(--muted);
}
.back {
  color: var(--blue-d);
  font-weight: 700;
  text-decoration: none;
}
.back:hover {
  color: var(--blue-text);
  text-decoration: underline;
}
.titleInput {
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
  padding: 5px 8px;
  min-width: 260px;
  max-width: 100%;
}
.titleInput:not([readonly]):hover {
  border-color: var(--border-strong);
}
.titleInput:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.item {
  padding-left: 14px;
  border-left: 1px solid var(--border);
}
.status {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 999px;
  background: var(--bg);
  color: var(--muted);
}
.banner {
  padding: 10px 26px;
  background: #f3fafc;
  border-bottom: 1px solid var(--border);
  color: var(--ink);
  font-size: 14px;
}
.warn {
  background: var(--amber-bg);
  border-bottom-color: var(--amber-line);
  border-left: 5px solid var(--amber-line);
}
.note {
  max-width: 1180px;
  margin: 34px auto;
  padding: 0 40px;
  color: var(--muted);
}
.copyError {
  color: var(--amber-text);
  font-weight: 700;
  font-size: 13px;
  margin: 6px 0 0;
}
.guestTitle {
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
  padding: 5px 0;
}
